define("shared/utils/analytics/timezone-helpers/index", ["exports", "shared/utils/analytics/timezone-helpers/compute-utc-offset-from-tz", "shared/utils/analytics/timezone-helpers/shift-time-to-end-of-local-day", "shared/utils/analytics/timezone-helpers/shift-time-to-start-of-local-day"], function (_exports, _computeUtcOffsetFromTz, _shiftTimeToEndOfLocalDay, _shiftTimeToStartOfLocalDay) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "computeUtcOffsetFromTz", {
    enumerable: true,
    get: function () {
      return _computeUtcOffsetFromTz.default;
    }
  });
  Object.defineProperty(_exports, "shiftTimeToEndOfLocalDay", {
    enumerable: true,
    get: function () {
      return _shiftTimeToEndOfLocalDay.default;
    }
  });
  Object.defineProperty(_exports, "shiftTimeToStartOfLocalDay", {
    enumerable: true,
    get: function () {
      return _shiftTimeToStartOfLocalDay.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"shared/utils/analytics/timezone-helpers/compute-utc-offset-from-tz",0,"shared/utils/analytics/timezone-helpers/shift-time-to-end-of-local-day",0,"shared/utils/analytics/timezone-helpers/shift-time-to-start-of-local-day"eaimeta@70e063a35619d71f
});